// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FriendlyCaptchaController from "./friendly_captcha_controller.js"
application.register("friendly-captcha", FriendlyCaptchaController)